module.exports = __webpack_public_path__ + "static/media/fanzhh_zhifubao_shoukuan.537cad14.png";